// 提供和环境相关的工具方法
const ENV_RELEASE = 'release'
const ENV_PRE_RELEASE = 'preRelease'
const ENV_PRODUCTION = 'production'
const ENV_TEST = 'test'
const ENV_LOCAL_DEVELOPMENT = 'development'
const ENV = import.meta.env.MODE

/**
 * 获取vite编译配置中的base值.
 * 由于在UT中无法mock vite的import.meta，只能对其数据的方法封装了一个方法，便于在单元测试中mock期返回值。*不要改变这个方法的实现*
 */
export function getBaseURL() {
  return import.meta.env.VITE_BASE_URL
}

export const Env = {
  isRelease: (): boolean => ENV === ENV_RELEASE,
  isPreRelease: (): boolean => ENV === ENV_PRE_RELEASE,
  isProduction: (): boolean => ENV === ENV_PRODUCTION,
  isTest: (): boolean => ENV === ENV_TEST,
  isLocalDev: (): boolean => ENV === ENV_LOCAL_DEVELOPMENT,
}
